import React from "react";
import { useTranslation } from "react-i18next";
import { InvoiceState } from "../enums/invoiceState";
import { isInfoviceBeforeDueDate } from "../helpers/invoiceHelper";

interface Props {
  state: InvoiceState;
  dueDate: Date;
}

const InvoiceStateInfo = ({ state, dueDate }: Props) => {
  // tanslations
  const { t } = useTranslation(["invoice\\enums\\invoiceState"]);

  // render
  switch (state) {
    case InvoiceState.Paid:
      return (
        <span className="badge badge-pill badge-success text-truncate font-weight-normal mw-100">
          {t(state)}
        </span>
      );
    case InvoiceState.PartiallyPaid:
    case InvoiceState.DirectDebitPayment:
    case InvoiceState.RepaymentSchedule:
    case InvoiceState.TransferToInvoice:
      return (
        <span className="badge badge-pill badge-warning text-truncate font-weight-normal mw-100">
          {t(state)}
        </span>
      );
    case InvoiceState.Concept:
    case InvoiceState.Active:
      if (isInfoviceBeforeDueDate(dueDate)) {
        return (
          <span className="badge badge-pill badge-warning text-truncate font-weight-normal mw-100">
            {t(state)}
          </span>
        );
      } else {
        return (
          <span className="badge badge-pill badge-danger text-truncate font-weight-normal mw-100">
            {t(state)}
          </span>
        );
      }
    case InvoiceState.Canceled:
      return (
        <span className="badge badge-pill badge-default text-white text-truncate font-weight-normal mw-100">
          {t(state)}
        </span>
      );
    default:
      return null;
  }
};

export default InvoiceStateInfo;
